import { RouteRecordRaw } from "vue-router";

export const orders: RouteRecordRaw = {
  path: "/orders",
  component: () =>
    import(/* webpackChunkName: "orders" */ "@/layouts/Default.vue"),
  children: [
    {
      path: "search",
      name: "Search",
      component: () =>
        import(/* webpackChunkName: "orders" */ "@/views/orders/Search.vue"),
      props: { orderType: "public" },
      meta: {
        isBeforeLogin: true
      }
    },
    {
      path: "search-limited-orders",
      name: "SearchLimitedOrders",
      component: () =>
        import(
          /* webpackChunkName: "orders" */ "@/views/orders/SearchTargetingOrders/SearchLimitedOrders.vue"
        ),
      meta: {
        isBeforeLogin: true
      }
    },
    {
      path: "search-individual-offer-orders",
      name: "SearchIndividualOfferOrders",
      component: () =>
        import(
          /* webpackChunkName: "orders" */ "@/views/orders/SearchTargetingOrders/SearchIndividualOfferOrders.vue"
        ),
      meta: {
        isBeforeLogin: true
      }
    },
    {
      path: "search-condition",
      name: "SearchCondition",
      component: () =>
        import(
          /* webpackChunkName: "orders" */ "@/views/orders/SearchCondition.vue"
        ),
      meta: {
        isBeforeLogin: true
      }
    },
    {
      path: "office/:officeId",
      name: "SearchByOffice",
      component: () => import("@/views/orders/SearchByOffice.vue"),
      meta: {
        isBeforeLogin: true,
        noindex: true
      }
    },
    {
      path: "detail/:orderId",
      name: "OrdersDetail",
      component: () =>
        import(/* webpackChunkName: "orders" */ "@/views/orders/Detail.vue"),
      meta: {
        isBeforeLogin: true,
        noindex: true
      }
    },
    {
      path: "detail/:orderId/job-posting",
      name: "OrdersDetailForJobPosting",
      component: () =>
        import(
          /* webpackChunkName: "orders_for_job_posting" */ "@/views/orders/DetailForJobPosting.vue"
        ),
      meta: {
        isBeforeLogin: true, // job-postingはログイン無しでも見られる必要がある
        // NOTE:
        // publicなっているprod以外の環境のjob-postingがGoogle for Jobsに拾われると、
        // 実在しない案件がGoogleのjob boardに載ってしまって良くないのでnoindexでコントロールする。
        // noindexが付いているとGoogleのクローラーはGoogle for Jobsのjob boardに掲載しなくなる。
        // ref: https://developers.google.com/search/docs/appearance/structured-data/job-posting?hl=ja#add-structured%20data
        // > Google がページにアクセスでき、robots.txt ファイル、noindex タグ、
        // > ログイン要件によってページがブロックされていないことを確認します。
        noindex: ["staging1", "staging2", "demo"]
      }
    },
    {
      path: "requirement-confirmation/:orderId/:workTimeOptionId",
      name: "OrdersRequirementConfirmation",
      component: () =>
        import(
          /* webpackChunkName: "orders" */ "@/views/orders/RequirementConfirmation.vue"
        )
    },
    {
      path: "cancel-policy/:orderId/:workTimeOptionId",
      name: "OrdersCancelPolicy",
      component: () =>
        import(
          /* webpackChunkName: "orders" */ "@/views/orders/CancelPolicy.vue"
        )
    },
    {
      path: "understanding-test/:orderId/:workTimeOptionId/start",
      name: "OrdersUnderstandingTestStart",
      component: () =>
        import(
          /* webpackChunkName: "orders" */ "@/views/orders/UnderstandingTestStart.vue"
        )
    },
    {
      path: "understanding-test/:orderId/:workTimeOptionId/question",
      name: "OrdersUnderstandingTestQuestion",
      component: () =>
        import(
          /* webpackChunkName: "orders" */ "@/views/orders/UnderstandingTestQuestion.vue"
        )
    },
    {
      path: "understanding-test/:orderId/:workTimeOptionId/finish",
      name: "OrdersUnderstandingTestFinish",
      component: () =>
        import(
          /* webpackChunkName: "orders" */ "@/views/orders/UnderstandingTestFinish.vue"
        )
    },
    {
      path: "last-confirmation/:orderId/:workTimeOptionId",
      name: "OrdersLastConfirmation",
      component: () =>
        import(
          /* webpackChunkName: "orders" */ "@/views/orders/LastConfirmation.vue"
        )
    },
    {
      path: "applications/:applicationId/message",
      name: "OrdersSendMessage",
      component: () =>
        import(
          /* webpackChunkName: "orders" */ "@/views/orders/SendMessage.vue"
        )
    },
    {
      path: "applications/:applicationId/calendar",
      name: "OrdersRegisterCalendar",
      component: () =>
        import(
          /* webpackChunkName: "orders" */ "@/views/orders/RegisterCalendar.vue"
        )
    },
    {
      path: "applications/:applicationId/reserve-completed",
      name: "OrdersReserveCompleted",
      component: () =>
        import(
          /* webpackChunkName: "orders" */ "@/views/orders/ReserveCompleted.vue"
        )
    },
    {
      path: "preview",
      name: "OrdersPreview",
      component: () =>
        import(/* webpackChunkName: "orders" */ "@/views/orders/Preview.vue"),
      meta: {
        isBeforeLogin: true
      }
    },
    {
      path: "cancel-policy-display",
      name: "OrdersCancelPolicyDisplay",
      component: () =>
        import(
          /* webpackChunkName: "orders" */ "@/views/orders/CancelPolicyDisplay.vue"
        ),
      props: route => ({
        applicationId: route.query.applicationId
      }),
      meta: {
        isBeforeLogin: true
      }
    }
  ]
};
